import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setParentCourse } from "../../Action/courseAction";
import { updateValues } from "../../Action/authAction";

const GoogleAuthSuccess = () => {
    const dispatch = useDispatch();
  
  useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const user = JSON.parse(params.get("user"));
      localStorage?.setItem("user",JSON?.stringify(user))
      dispatch(updateValues("googleProfile",user))

    window.close();
  }, []);

  return <p>Signing you in…</p>;
};

export default GoogleAuthSuccess;
